<div class="file-drop-zone" [class.drag-over]="dragOver"
     (dragover)="onDragOver($event)" (dragleave)="onDragLeave()" (drop)="onDrop($event)">
  <div class="drop-label">{{ fileTitle }}</div>

  @if (existingFilename) {
    <div class="existing-file">
      <i class="pi pi-file"></i> {{ existingFilename }}
      @if (fileKey) {
        <button type="button" class="delete-btn" (click)="deleteFile()"
                [disabled]="deleting" title="Delete file">
          <i class="pi pi-trash"></i>
        </button>
      }
    </div>
  }

  @if (!uploading) {
    <div class="drop-instructions">
      <span>Drag file here or</span>
      <label class="browse-btn">
        browse
        <input type="file" (change)="onFileSelect($event)" style="display: none;" />
      </label>
    </div>
  }

  @if (uploading) {
    <p-progressBar [value]="uploadProgress" />
  }
</div>
